import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../api/api";
import Navbar from "../components/Navbar";
import { errorAlert } from "../utils/alert";

const Verify = () => {
  const { type, id, eventId, escortIdx } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        let url = "";
        if (type === "escort") {
          url = `/verify/escort/${id}/${eventId}/${escortIdx}`;
        } else {
          url = `/verify/player/${id}/${eventId}`;
        }

        const res = await API.get(url);
        setData(res);

      } catch (err) {
        setError(err?.message || "Invalid or unverified registration.");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [type, id, eventId, escortIdx]);

  useEffect(() => {
    if (!error) return;
    errorAlert("Verification failed", error);
  }, [error]);

  const getStatusColor = (status) => {
    const s = String(status || "").toLowerCase();
    if (s === "approved") return "bg-green-100 text-green-800 border-green-200";
    if (s === "pending") return "bg-yellow-100 text-yellow-800 border-yellow-200";
    return "bg-red-100 text-red-800 border-red-200";
  };

  return (
    <>
      <Navbar />
      <div className="flex flex-col items-center mt-12 sm:mt-20 text-center px-4 mobile-page-pad">
        {loading && (
          <div className="flex flex-col items-center gap-3">
            <div className="w-12 h-12 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
            <p className="text-blue-600 font-medium">Verifying ID Card...</p>
          </div>
        )}
        {error && (
          <div className="bg-red-50 border border-red-200 rounded-xl p-6 w-full max-w-md shadow-sm">
            <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-2xl text-red-600">✕</span>
            </div>
            <h2 className="text-lg font-bold text-red-800 mb-1">Verification Failed</h2>
            <p className="text-red-600 font-medium text-sm">{error}</p>
          </div>
        )}
        {data && (
          <div className="bg-white shadow-xl rounded-2xl p-6 sm:p-8 w-full max-w-md border border-gray-100 relative overflow-hidden transition-all duration-300 hover:shadow-2xl">
            {/* Top decorative badge */}
            <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-r from-emerald-400 to-teal-600"></div>
            
            <div className="w-16 h-16 bg-emerald-50 rounded-full flex items-center justify-center mx-auto mb-5 border border-emerald-100">
              <span className="text-3xl text-emerald-500">✓</span>
            </div>

            {data.is_escort ? (
              <>
                <h2 className="text-xl sm:text-2xl text-emerald-800 font-extrabold mb-5 tracking-tight">Verified Escort</h2>
                
                <div className="space-y-4 text-left border-t border-gray-50 pt-4">
                  <div>
                    <label className="text-xs font-semibold text-gray-400 uppercase tracking-wider">Escort Name</label>
                    <p className="font-bold text-gray-800 text-lg mt-0.5">{data.escort_name}</p>
                  </div>
                  
                  <div>
                    <label className="text-xs font-semibold text-gray-400 uppercase tracking-wider">Escort Type</label>
                    <p className="font-semibold text-gray-700 mt-0.5">{data.escort_type}</p>
                  </div>

                  <div>
                    <label className="text-xs font-semibold text-gray-400 uppercase tracking-wider">For Player</label>
                    <p className="font-semibold text-gray-700 mt-0.5">{data.player_name}</p>
                  </div>

                  <div>
                    <label className="text-xs font-semibold text-gray-400 uppercase tracking-wider">Event Name</label>
                    <p className="text-gray-600 text-sm mt-0.5">{data.event_title}</p>
                  </div>

                  <div className="flex justify-between items-center pt-2">
                    <div>
                      <label className="text-xs font-semibold text-gray-400 uppercase tracking-wider">Status</label>
                      <div className="mt-1">
                        <span className={`px-2.5 py-1 text-xs font-bold rounded-full border ${getStatusColor(data.status)}`}>
                          {data.status}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <h2 className="text-xl sm:text-2xl text-emerald-800 font-extrabold mb-5 tracking-tight">Verified Player Registration</h2>
                
                <div className="space-y-4 text-left border-t border-gray-50 pt-4">
                  <div>
                    <label className="text-xs font-semibold text-gray-400 uppercase tracking-wider">Player Name</label>
                    <p className="font-bold text-gray-800 text-lg mt-0.5">{data.player_name}</p>
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="text-xs font-semibold text-gray-400 uppercase tracking-wider">Sport</label>
                      <p className="font-semibold text-gray-700 mt-0.5">{data.sport_name}</p>
                    </div>

                    <div>
                      <label className="text-xs font-semibold text-gray-400 uppercase tracking-wider">Registration ID</label>
                      <p className="font-mono font-bold text-gray-700 mt-0.5">{data.registration_id}</p>
                    </div>
                  </div>

                  <div>
                    <label className="text-xs font-semibold text-gray-400 uppercase tracking-wider">Event Title</label>
                    <p className="text-gray-600 text-sm mt-0.5">{data.event_title}</p>
                  </div>

                  <div className="flex justify-between items-center pt-2">
                    <div>
                      <label className="text-xs font-semibold text-gray-400 uppercase tracking-wider">Status</label>
                      <div className="mt-1">
                        <span className={`px-2.5 py-1 text-xs font-bold rounded-full border ${getStatusColor(data.status)}`}>
                          {data.status}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default Verify;
